import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { toSHA256 } from '../utils/hash';

@Injectable({
  providedIn: 'root',
})
export class AccessHashService {
  public hashState$ = new BehaviorSubject<string | undefined>(undefined);

  constructor() {
    const hash = localStorage.getItem('access-hash');
    if (hash) {
      this.handleHash(hash);
    }
  }

  public setBirthday(birthday?: string) {
    const hash = toSHA256(birthday);
    this.handleHash(hash);
  }

  public setHash(hash: string) {
    this.handleHash(hash);
  }

  public clearHash() {
    this.handleHash(undefined);
  }

  public removeHash() {
    localStorage.removeItem('access-hash');
    this.handleHash(undefined);
  }

  private handleHash(hash?: string) {
    this.hashState$.next(hash);
    if (hash) {
      localStorage.setItem('access-hash', hash);
    }
  }

  public get hashState() {
    return this.hashState$;
  }
}
